import { render, staticRenderFns } from "./ImageHolder.vue?vue&type=template&id=4cf79131&scoped=true&"
import script from "./ImageHolder.vue?vue&type=script&lang=js&"
export * from "./ImageHolder.vue?vue&type=script&lang=js&"
import style0 from "@@/core/components/shared/ImageHolder/ImageHolderStyle.css?vue&type=style&index=0&id=4cf79131&scoped=true&lang=css&"
import style1 from "@@/core/components/shared/ImageHolder/ImageHolderStylePublic.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf79131",
  null
  
)

export default component.exports